import { Module } from 'vuex';
import { RootState } from '../types';
import { InspectorsState } from './types';
import { Inspector } from '@/models/inspector.model';

import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

/**
 * Default state
 */
export const state: InspectorsState = {
  current: new Inspector(),
  list: [],
  default: new Inspector(),
  updates: [],
};

/**
 * Use namespaced Vuex modules
 */
const namespaced: boolean = true;

/**
 * Module export
 */
const inspectors: Module<InspectorsState, RootState> = {
  state,
  getters,
  mutations,
  actions,
  namespaced,
};

export default inspectors;
